import styled from '@emotion/styled';

import { hoverable } from '../../interaction-states';
import { typographyVariantStyles } from '../../typography-variants';
import { WHEEL_ROW_HEIGHT, WHEEL_VIEWPORT_HEIGHT } from './constants';

export const StyledWheelColumn = styled('div')({
  flex: 1,
  height: WHEEL_VIEWPORT_HEIGHT,
  overflowY: 'auto',
  scrollSnapType: 'y mandatory',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',

  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const StyledWheelSpacer = styled('div')({
  height: WHEEL_ROW_HEIGHT,
  flexShrink: 0,
});

export const StyledWheelRow = styled('div', {
  shouldForwardProp: (prop) => prop !== '$centered',
})<{ $centered?: boolean }>(({ theme, $centered }) => ({
  ...hoverable(theme),
  height: WHEEL_ROW_HEIGHT,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  scrollSnapAlign: 'center',
  cursor: 'pointer',
  userSelect: 'none',

  ...($centered
    ? { ...typographyVariantStyles.body2, fontWeight: 500, color: theme.colors.text.primary }
    : { ...typographyVariantStyles.body3, fontWeight: 500, color: theme.colors.text.tertiary }),
}));
